var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usage-and-invoices"},[_c('section',{staticClass:"section--usage"},[_c('h1',{staticClass:"title is-5"},[_vm._v(" Kostenübersicht "),_c('b-select',{staticClass:"is-pulled-right",attrs:{"size":"is-small","type":"is-primary","placeholder":"Zeitraum wählen"},on:{"input":_vm.setRange},model:{value:(_vm.selectedRange),callback:function ($$v) {_vm.selectedRange=$$v},expression:"selectedRange"}},_vm._l((_vm.ranges),function(range,i){return _c('option',{key:'r' + i,domProps:{"value":i}},[_vm._v(_vm._s(_vm._f("formatDate")(range.from))+" bis "+_vm._s(_vm._f("formatDate")(range.to)))])}),0)],1),(!_vm.loading && _vm.usage.total.gross > 0)?_c('div',{staticClass:"usage"},[_c('div',{staticClass:"usage-types"},[_c('PieChart',{attrs:{"data":[
            {
              value: _vm.usage.types.C100.gross,
              color: 'hsl(220, 61%, 57%)',
              label: 'C100'
            },
            {
              value: _vm.usage.types.C200.gross,
              color: 'hsl(220, 61%, 47%)' /*primary*/,
              label: 'C200'
            },
            {
              value: _vm.usage.types.C400.gross,
              color: 'hsl(220, 61%, 37%)',
              label: 'C400'
            },
            {
              value: _vm.usage.types.C100P.gross,
              color: 'hsl(100, 61%, 57%)',
              label: 'C100P'
            },
            {
              value: _vm.usage.types.C200P.gross,
              color: 'hsl(100, 61%, 47%)' /*primary*/,
              label: 'C200P'
            },
            {
              value: _vm.usage.types.C400P.gross,
              color: 'hsl(100, 61%, 37%)',
              label: 'C400P'
            },
            {
              value: _vm.usage.types.image.gross,
              color: '#ff3860',
              label: 'Image'
            }
          ]}})],1),_c('div',{staticClass:"usage-costs"},[_c('strong',{staticClass:"costs__item costs__item--title"},[_vm._v("Kosten")]),_vm._l((_vm.usage.servers),function(server){return _c('span',{key:'s' + server.id,staticClass:"costs__item"},[_c('em',[_vm._v(_vm._s(server.name))]),_c('span',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("pricing")(server.usage.gross)))])])}),_c('strong',{staticClass:"costs__item costs__item--total"},[_vm._v("Gesamtkosten"),_vm._m(0),_c('span',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("pricing")(_vm.usage.total.gross)))])])],2)]):_c('div',[_vm._v(" Keine Kosten vorhanden. ")]),_c('b-loading',{attrs:{"loading":_vm.loading}})],1),_c('hr'),_vm._m(1),_c('hr'),_c('p',{staticStyle:{"font-size":".85em"}},[_vm._v(" 1) Die angegebenen Gesamtkosten sind eine Schätzung nach aktuellem Verbrauch, ohne Support-/Setupgebühren. Es gelten die in Rechnung gestellten Gebühren. ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',[_c('sup',[_vm._v("1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section--invoices"},[_c('h1',{staticClass:"title is-5"},[_vm._v(" Rechnungen ")]),_c('p',[_vm._v("Keine Rechnung vorhanden.")])])}]

export { render, staticRenderFns }